export default __webpack_public_path__ + "static/media/cdn.d3baffa0.svg";